module.exports = __webpack_public_path__ + "static/img/3.424875b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/3.png
// module id = lZUs
// module chunks = 0